module.exports = __webpack_public_path__ + "img/mcgl_fp_05.f0b64483.png";